const isSameOrigin = (url: string | null): boolean => {
  if (!url) {
    return true;
  }

  const stylesheetUrl = new URL(url, window.location.href);
  return stylesheetUrl.origin === window.location.origin;
};

export const extractStylesheetRules = (stylesheet: CSSStyleSheet): string => {
  if (isSameOrigin(stylesheet.href)) {
    if (stylesheet.cssRules) {
      return Array.from(stylesheet.cssRules).reduce(
        (acc, rule, index) => acc + (index > 0 ? '\n' : '') + rule.cssText,
        ''
      );
    }
  }

  return '';
};